import { Navigate } from "react-router-dom";

import { NotFoundView } from "@/components/not-found-view";
import { ProtectedRoute } from "@/routes/protected-route";

import { AdminRootLayout } from "./admin/admin-root.layout";
import { AdminWorkspaceAllPage } from "./admin/admin-workspace-all.page";
import { AdminWorkspaceDetailPage } from "./admin/admin-workspace-detail.page";
import { WorkspaceSettingsGeneralPage } from "./workspace-settings-general.page";
import { WorkspaceSettingsMembershipPage } from "./workspace-settings-membership.page";

export const workspaceSettingsRoutes = [
  { path: "", element: <Navigate to="general" replace /> },
  { path: "general", element: <WorkspaceSettingsGeneralPage /> },
  { path: "members", element: <WorkspaceSettingsMembershipPage /> },
];

export const workspaceAdminRoutes = (isAuthenticated: boolean) => {
  return [
    {
      path: "/admin",
      element: <ProtectedRoute isAuthenticated={isAuthenticated}>{<AdminRootLayout />}</ProtectedRoute>,
      children: [
        { path: "", element: <Navigate to="workspaces" replace /> },
        { path: "workspaces", element: <AdminWorkspaceAllPage /> },
        { path: "workspaces/:workspaceId", element: <AdminWorkspaceDetailPage /> },
        { path: "*", element: <NotFoundView /> },
      ],
    },
  ];
};
